export enum MailboxType {
  Personal = 'personal',
  Shared = 'shared',
}